export const dateTimeFormats = {
  selectedDate: "EEEE, MMMM d",
  dateWithTz: "yyyy-MM-dd'T'HH:mm:ssXXX",
  yearMonthDay: "yyyy-MM-dd",
};
